export enum NavItems {
    ContractChange = 'ContractChange',
    PriceListUER = 'PriceListUER',
    PriceListMTR = 'PriceListMTR',
    PriceListRatio = 'PriceListRatio',
    ContractOther = 'ContractOther',
    ContractActsKC3 = 'ContractActsKC3',
    ContractStructure = 'ContractStructure',
    ContractObject = 'ContractObject',
    ContractCalculation = 'ContractCalculation',
    WorkOrderActsKC2 = 'WorkOrderActsKC2',
    CalculationUers = 'CalculationUers',
    CalculationRatios = 'CalculationRatios',
    CalculationStructure = 'CalculationStructure',
    CalculationVor = 'CalculationVor',
    CalculationMtrs = 'CalculationMtrs',
    CalculationOther = 'CalculationOther',
    CalculationPreview = 'CalculationPreview',
    CalculationLimitedCosts = 'CalculationLimitedCosts',
    CalculationLocalEstimate = 'CalculationLocalEstimate',
}
